import React from 'react';
import { Link } from 'react-router-dom';
import { HelpHero } from '../components/HelpHero';
import { Breadcrumb } from '../components/Breadcrumb';
import { Tag, Gift } from 'lucide-react';
import { articles, categories } from '../data/articles';
export function PromotionsPage() {
  const categoryArticles = articles.filter(a => a.categorySlug === 'promociones-y-descuentos');
  return <div className="min-h-screen bg-[#f8fafc]" data-id="element-391">
      <HelpHero title="Promociones y Descuentos" subtitle="Ahorra más en tu salud con nuestros beneficios exclusivos." showSearch={true} data-id="element-392" />

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-id="element-393">
        <div className="flex flex-col lg:flex-row gap-10" data-id="element-394">
          {/* Left Sidebar */}
          <aside className="w-full lg:w-1/4 flex-shrink-0" data-id="element-395">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 sticky top-6" data-id="element-396">
              <h3 className="font-bold text-[#022a3b] mb-4 text-lg" data-id="element-397">
                Centro de Ayuda
              </h3>
              <nav className="space-y-1" data-id="element-398">
                {categories.map(category => <Link key={category.slug} to={`/${category.slug}`} className={`block py-2.5 px-3 rounded-md transition-colors ${category.slug === 'promociones-y-descuentos' ? 'bg-[#f0f9ff] text-[#0af] font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-[#022a3b]'}`} data-id="element-399">
                    {category.name}
                  </Link>)}
              </nav>
            </div>
          </aside>

          {/* Right Content */}
          <div className="w-full lg:w-3/4" data-id="element-400">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-10 mb-8" data-id="element-401">
              <Breadcrumb items={[{
              label: 'Promociones y descuentos'
            }]} data-id="element-402" />

              <div className="flex items-center gap-3 mb-8" data-id="element-403">
                <div className="p-2 bg-[#fff7ed] rounded-lg text-[#ff5a00]" data-id="element-404">
                  <Tag className="h-6 w-6" data-id="element-405" />
                </div>
                <h1 className="text-3xl font-bold text-[#022a3b]" data-id="element-406">
                  Promociones y descuentos
                </h1>
              </div>

              <p className="text-gray-600 mb-8" data-id="element-407">
                Encuentra aquí la información referente a nuestras promociones y
                cómo empezar a aplicarlas en tus compras
              </p>

              <div className="space-y-0 divide-y divide-gray-100" data-id="element-408">
                {categoryArticles.map(article => <Link key={article.slug} to={`/${article.slug}`} className="block py-4 text-[#022a3b] hover:text-[#0af] transition-colors" data-id="element-409">
                    {article.title}
                  </Link>)}
              </div>
            </div>

            <div className="bg-gradient-to-r from-[#ff5a00] to-[#ffc200] rounded-2xl p-8 text-white relative overflow-hidden" data-id="element-410">
              <div className="relative z-10" data-id="element-411">
                <h2 className="text-2xl font-bold mb-4" data-id="element-412">
                  ¿Primera vez en Vitau?
                </h2>
                <p className="text-lg mb-6 max-w-xl" data-id="element-413">
                  Suscríbete a nuestro boletín y recibe un 10% de descuento en
                  tu primera compra de medicamentos.
                </p>
                <button className="bg-white text-[#ff5a00] px-6 py-2 rounded-md font-bold hover:bg-gray-50 transition-colors" data-id="element-414">
                  Obtener Cupón
                </button>
              </div>
              <Gift className="absolute right-8 bottom-[-20px] h-40 w-40 text-white/20 rotate-12" data-id="element-415" />
            </div>
          </div>
        </div>
      </main>
    </div>;
}